import React from "react";
import styles from "./AppDown.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faScrewdriverWrench } from "@fortawesome/free-solid-svg-icons";

export default function AppDown() {
    return <div className={styles.downTop}>
        <FontAwesomeIcon size={"2x"} className={styles.icon} icon={faScrewdriverWrench} />
        <div>
            <p>{"We’ll be back soon."}</p>
            <p>{"AboutMyProperty will be temporarily unavailable while we complete a planned system update. This work is part of MPAC’s broader modernization efforts to strengthen the tools and services that support your needs. Thank you for your patience and understanding."}</p>
            <p>{"Nous serons bientôt de retour."}</p>
            <p>{"AboutMyProperty sera temporairement indisponible pendant que nous effectuons une mise à jour systématique prévue. Ce travail s'inscrit dans le cadre des efforts de modernisation de la SEFM visant à renforcer les outils et les services qui répondent à vos besoins. Nous vous remercions de votre patience et de votre compréhension."}</p>
        </div>
        <FontAwesomeIcon size={"2x"} className={styles.icon} icon={faScrewdriverWrench} />
    </div>
}